export default (eventName) => {
  window.analytics.track(eventName, {}, () => {
    console.log(`[ Segment ] - ${eventName}`)
  })
}
